import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierCL.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'gateway.PremierCL.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'gateway.PremierCL.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'gateway.PremierCL.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierCL.wizard.error',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierCL.wizard.error.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierCL.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierCL.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
});
